export const password = {
  validate: value =>
    new RegExp(/^.*(?=.{6,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\d]).*$/).test(value)
};
